import { STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

export const useCheckoutRedesignExperiment = () => {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.CHECKOUT_REDESIGN)
  return experimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.CHECKOUT_REDESIGN].buckets?.Show
}
